import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationUtil, ValidationMessages } from '../../utils/validation';

@Component({
  selector: 'control-label',
  templateUrl: './control-label.component.html',
  styleUrls: []
})
export class ControlLabelComponent {
  @Input() public control!: AbstractControl<any>;
  @Input() public fieldName: any;
  public errMessage: any;

  constructor() { }

  errorMessage() {
    for (const error in this.control.errors) {
      if (this.control.errors.hasOwnProperty(error) && this.control.touched) {
        this.errMessage = ValidationUtil.getValidatorErrorMessage(
          error as keyof ValidationMessages,
          this.control.errors[error],
          this.fieldName
        );
        return this.errMessage;
      }
    }
    return null;
  }

}
